import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { returnsApi, type ReturnRequest } from '../../api/returns';

export function ReverseLogisticsPage() {
  const [returns, setReturns] = useState<ReturnRequest[]>([]);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    void returnsApi.listReturns().then(setReturns);
  }, []);

  async function schedulePickup(ret: ReturnRequest) {
    await returnsApi.scheduleReversePickup(ret.id);
    setMsg(`Reverse pickup scheduled for ${ret.return_number}`);
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/returns" className="text-sm text-slate-600 hover:underline">← Returns hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Reverse logistics</h1>
      {msg && <p className="mt-2 text-sm text-green-700">{msg}</p>}
      <ul className="mt-4 space-y-2">
        {returns.filter((r) => r.status === 'approved').map((r) => (
          <li key={r.id}>
            <button type="button" onClick={() => void schedulePickup(r)}
              className="rounded border px-3 py-2 text-sm">Schedule pickup — {r.return_number}</button>
          </li>
        ))}
      </ul>
    </div>
  );
}
